import { Component, OnInit, ViewChild } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { Table } from 'primeng/table';
import { Router } from '@angular/router';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { PoliticasCredito } from '../../_models/politicas-credito';
import { PoliticasCreditoService } from '../../_services/politicas-credito.service';

@Component( {
  selector: 'app-politicas-credito-listado',
  templateUrl: 'politicas-credito-listado.component.html'
} )

export class PoliticasCreditoListadoComponent implements OnInit {

  politicas: PoliticasCredito[] = [];
  carPoliticas = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private politicasCreditoServicio: PoliticasCreditoService,
               private navServicio: NavService,
               private autServicio: AutenticacionService,
               private router: Router ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/politicas-credito' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'POLITICAS.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'POLITICAS.LBL_NOMBRE' ), sort: true },
      { field: 'tipo', header: this.navServicio.buscarMensaje( 'POLITICAS.LBL_TIPO' ), sort: true },
      { field: 'indicadorTitular', header: this.navServicio.buscarMensaje( 'POLITICAS.LBL_TITULAR' ), sort: true },
      { field: 'indicadorDeudorSolidario', header: this.navServicio.buscarMensaje( 'POLITICAS.LBL_DEUDOR' ), sort: true },
      { field: 'indicadorCodeudor', header: this.navServicio.buscarMensaje( 'POLITICAS.LBL_CODEUDOR' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'politicas.component' );

    this.politicasCreditoServicio.listadoPoliticas().subscribe( politicas => {
      this.politicas = politicas;
      this.carPoliticas = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crearPolitica(){
    this.router.navigate(['apl/politicas-credito/agregar']);
  }

  ver( politica: PoliticasCredito ) {
    this.router.navigate( [ 'apl/politicas-credito/detalle/' + politica.idPoliticaCredito ] );
  }

  editar( politica: PoliticasCredito ) {
    this.router.navigate( [ 'apl/politicas-credito/actualizar/' + politica.idPoliticaCredito ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'politicas.component', this.busqueda );
  }

}
